export const Name = 'funnel-question-with-position';
